<template>
  <!-- 明细弹窗 -->
  <div>
    <Modal v-model="visible" title="提现结算单" :mask-closable="false" width="1200px" class="my-modal" :footer-hide="true">
      <Table :columns="columns" :data="tableDate" @on-selection-change="tableSelect">
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="lookDetail(row)">明细</span>
        </template>

        <template slot-scope="{ row }" slot="detail">
          <div>
            <!-- <span v-if="(row.detail && row.detail != '[]') || row.deliveryId || row.receipt" class="table-btn" @click="lookInvoice(row)">查看发票</span> -->
            <span class="table-btn" @click="lookInvoice(row)">查看发票</span>
          </div>
        </template>
      </Table>
      <div
        class="ivu-modal-footer"
        v-if="
          (tableItem.okbStatus == '-2' && $units.pointAction('offline_81_7_btn6')) ||
          (['3'].includes(tableItem.okbStatus) && $units.pointAction('offline_81_7_btn7'))
        "
      >
        <Button type="primary" ghost @click="visible = false">取消</Button>
        <Button type="primary" @click="submit">
          <span v-if="tableItem.okbStatus == 3">打款</span>
          <span v-else>确认发放</span>
        </Button>
      </div>
    </Modal>
    <!-- 短信验证 -->
    <okbao-check ref="okbaoCheck" @reload="reload" :type="tableItem.okbStatus == -1 ? 'rePay' : ''" />
    <!-- 标记已支付时选择打款日期 -->
    <select-date-modal ref="selectDateModal" v-if="$refs.okbaoCheck" @save="$refs.okbaoCheck.open" />

    <invoiceModal ref="invoiceModalRef" @success="getList()" />
  </div>
</template>
<script>
import okbaoCheck from './okbaoCheck';
import selectDateModal from './selectDateModal';
import { common } from '@/api/mixins';
import invoiceModal from './invoiceModal';
import { config } from './withdrawalList.config.js';
export default {
  components: {
    invoiceModal,
    selectDateModal,
    okbaoCheck
  },
  mixins: [common, config],
  data() {
    return {
      visible: false,
      columns: [],
      tableDate: [],
      tableItem: {}, // 外部表格数据
      searchParams: {}, // 外部查询数据
      selectArr: []
    };
  },
  computed: {},
  methods: {
    // 打开弹窗
    open(data, searchParams) {
      this.visible = true;
      this.tableItem = data;
      this.searchParams = searchParams;
      this.selectArr = [];
      this.getColumns();
      this.getList();
    },
    getList() {
      this.$http({
        url: '/buz/userCashWithdrawLog/queryOkbDetailList',
        type: 'POST',
        data: {
          okbStatus: this.searchParams.okbStatus,
          userId: this.tableItem.userId,
          id: this.tableItem.id,
          reportIds: this.tableItem.reportIds
        }
      }).then(res => {
        res.data.forEach(item => {
          // item._checked = true;
          if ([-1, 3].includes(this.tableItem.okbStatus * 1)) {
            this.selectArr.push(item);
          }
        });
        this.tableDate = res.data;
      });
    },
    // 操作完成刷新
    reload() {
      this.$emit('reload');
      this.visible = false;
      this.$refs.selectDateModal.visible = false;
    },
    // 选择表格数据
    tableSelect(selection) {
      this.selectArr = selection;
    },
    lookInvoice(row) {
      this.$refs.invoiceModalRef.open(row);
    },
    // 查看明细
    lookDetail(row) {
      if (row.issueType == 3) {
        // 风险单
        this.openPageTabTags('/financialManage/riskOrderOK/riskOrderList', {
          riskPolicyIds: row.riskPolicyIds.join(',') || '',
          backUrl: this.delQueStr(this.$route.fullPath, 'time')
        });
      } else {
        this.openPageTabTags('/financialManage/salesmanPaySettlement/detail', {
          reportId: row.reportId,
          tabVal: 1,
          userId: row.userId,
          issueType: row.issueType, // 1正常发放 2风险结算单发放 3风险保单发放
          pageType: 'withdrawalOK'
        });
      }
    },
    // 提交
    submit() {
      if (this.selectArr.length == 0) {
        this.$notice.error('请选择至少一个结算单');
        return;
      }
      const params = {
        userIds: [this.tableItem.userId],
        operationType: 1
      };
      if (this.tableItem.okbStatus == -1) {
        // 重新付款
        params.idList = [this.tableItem.id];
        params.reportIds = this.tableItem.reportIds;
      } else {
        params.reportIds = this.selectArr.map(item => item.reportId);
      }
      if (this.tableItem.okbStatus == 3) {
        params.okbStatus = 3;
        params.idList = this.selectArr.map(i => i.id);
      }
      this.$refs.okbaoCheck.open(params);
    }
  }
};
</script>

<style lang="scss" scoped>
.my-modal {
  /deep/ .ivu-modal-body {
    padding-top: 20px;
  }
}
</style>
